var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccesssmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    viewBox: "0 0 105 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 104,
    height: 44,
    rx: 7.5,
    fill: "#212731",
    stroke: "url(#paint0_linear_621_521)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 36.4915C54.5 36.3113 54.5969 36.1451 54.7537 36.0563L64.8489 30.3421C65.0043 30.2541 65.1948 30.2557 65.3487 30.3462L69.4537 32.761C69.7855 32.9561 69.7816 33.4371 69.4468 33.6269L55.2466 41.6767C54.9133 41.8657 54.5 41.6249 54.5 41.2418V36.4915Z",
    fill: "url(#paint1_linear_621_521)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13.1576C34 12.7746 34.413 12.5338 34.7463 12.7225L39.0463 15.1564C39.2031 15.2452 39.3 15.4114 39.3 15.5916V27.6085C39.3 27.7887 39.2031 27.9549 39.0463 28.0437L34.7463 30.4776C34.413 30.6663 34 30.4255 34 30.0425V13.1576Z",
    fill: "url(#paint2_linear_621_521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7541 7.04352C54.5971 6.95484 54.5 6.78849 54.5 6.60816V1.85756C54.5 1.47456 54.913 1.23376 55.2463 1.42243L69.646 9.5732C69.981 9.76284 69.985 10.2441 69.6532 10.4393L65.5484 12.8539C65.3947 12.9443 65.2044 12.946 65.049 12.8582L54.7541 7.04352Z",
    fill: "url(#paint3_linear_621_521)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5654 10.3353C36.228 10.1435 36.2283 9.6571 36.5659 9.4657L50.7532 1.42322C51.0865 1.23427 51.4998 1.47504 51.4998 1.85819V6.60607C51.4998 6.78751 51.4015 6.95471 51.243 7.04295L41.1456 12.6632C40.993 12.7481 40.8071 12.7473 40.6553 12.661L36.5654 10.3353Z",
    fill: "url(#paint4_linear_621_521)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9478 27.8449C66.7944 27.7552 66.7002 27.5909 66.7002 27.4133V15.8916C66.7002 15.7115 66.7971 15.5452 66.9539 15.4565L71.2539 13.0225C71.5872 12.8339 72.0002 13.0747 72.0002 13.4577V29.9284C72.0002 30.3146 71.5811 30.555 71.2478 30.36L66.9478 27.8449Z",
    fill: "url(#paint5_linear_621_521)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6633 33.7307C36.326 33.5404 36.3237 33.0556 36.6591 32.8621L40.8521 30.443C41.0056 30.3544 41.1946 30.3537 41.3487 30.4412L51.2466 36.0564C51.4032 36.1452 51.4999 36.3113 51.4999 36.4913V41.2439C51.4999 41.6266 51.0876 41.8674 50.7542 41.6794L36.6633 33.7307Z",
    fill: "url(#paint6_linear_621_521)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 27.3071L42.7998 15.8905L52.9998 10.0755L63.1998 15.8905V27.3071L52.9998 33.0268L42.7998 27.3071Z",
    fill: "url(#paint7_linear_621_521)",
    stroke: "url(#paint8_linear_621_521)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_521",
    x1: 52.5,
    y1: 0,
    x2: 52.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57796B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57796B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_521",
    x1: 54.9344,
    y1: 38.3168,
    x2: 66.9203,
    y2: 31.2638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_521",
    x1: 36.2998,
    y1: 29.5715,
    x2: 43.3814,
    y2: 25.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375473,
    stopColor: "#90F243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BD23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_521",
    x1: 68,
    y1: 11.5,
    x2: 54.7937,
    y2: 4.38272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_621_521",
    x1: 52,
    y1: 3,
    x2: 38.2252,
    y2: 11.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_621_521",
    x1: 69,
    y1: 29.5001,
    x2: 76.0103,
    y2: 25.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_621_521",
    x1: 49.1452,
    y1: 40.625,
    x2: 36.175,
    y2: 33.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432765,
    stopColor: "#90F243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BD23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_621_521",
    x1: 42.892,
    y1: 25.9382,
    x2: 61.9042,
    y2: 18.4084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_621_521",
    x1: 52.9998,
    y1: 9.5,
    x2: 52.9998,
    y2: 33.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesssmall);
export default __webpack_public_path__ + "static/media/successsmall.c6dad725068e60c8953f33dcb013713c.svg";
export { ForwardRef as ReactComponent };